import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-text-snippet',
  templateUrl: './text-snippet.component.html',
  styleUrls: ['./text-snippet.component.scss']
})
export class TextSnippetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
